module.exports = __webpack_public_path__ + "static/media/betterprompts.d0209e89.jpeg";